const BACKEND_URL = "https://miyogur.rapidito.uy";

export const getBackendBaseUrl = () => BACKEND_URL;

export const BACKEND_ENDPOINTS = {
  health: "/api/health",
  catalog: "/api/catalog",
  currentUser: "/api/me",
  login: "/api/auth/login",
  logout: "/api/auth/logout",
};
